import axios from './instance'

export const getAllDocuments = async (id) => {
  try {
    const res = await axios.get(`http://localhost:8000/api/documents/${id}`);
    return res.data;
  } catch (error) {
    console.error("Error fetching documents:", error);
    console.log();
    throw error;
  }
};
export const getDocumentById = async (documentId) => {
  try {
    const res = await axios.get(`http://localhost:8000/api/documents/${documentId}`);
    return res.data;
  } catch (error) {
    console.error("Error fetching document:", error);
    throw error;
  }
};

export const createDocument = async (documentData) => {
  try {
    const res = await axios.post(`http://localhost:8000/api/documents`, documentData); 
    return res.data;
  } catch (error) {
    console.error("Error creating document:", error);
    throw error;
  }
};


export const updateDocument = async (documentId, updatedData) => {
    try {
      const res = await axios.patch(`http://localhost:8000/api/documents/${documentId}`, updatedData);
      return res.data;
    } catch (error) {
      console.error("Error updating document:", error);
      throw error;
    }
  };

  export const deleteDocument = async (id) => {
    try {
      const res = await axios.delete(`http://localhost:8000/api/documents/${id}`,);
      return res.data;
    } catch (error) {
      console.error(`Error deleting documents with ID ${id}:`, error);
      throw error;
    }
  };
  
  